module.exports = __webpack_public_path__ + "static/media/award.3ad9100b.jpg";